var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileStoryShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.428 10.399q-7.608 8.565-8.59 8.566c-1.017 0-1.017-.807-1.017-1.084v-3.793q-1.682-.792-4.58 1.084C2.341 17.048 1.791 19.973.69 20c-1.102.026-.634-3.748-.306-5.116l.312-1.259c1.062-4.153 3.185-8.82 9.124-8.748V1.626c0-.278 0-1.626 1.018-1.626q.982 0 8.608 9.092a1 1 0 0 1-.019 1.307"
})));
export default SvgFacebookMobileStoryShare;